import { useEffect, useRef, useState } from "react";

export default function PopupWrapper({ trigger, children, onClose, onOpen }) {
  const [open, setOpen] = useState(false);
  const [pos, setPos] = useState({ top: 0, left: 0 });
  const triggerRef = useRef(null);
  const popupRef = useRef(null);

  const close = () => {
    setOpen(false);

    if (onClose) onClose();
  };

  const toggle = () => {
    if (!open && triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();

      setPos({
        // ✅ CHANGED: removed window.scrollY (FIXED positioning uses viewport coords)
        top: rect.top - 10,

        // ✅ CHANGED: removed window.scrollX for same reason
        left: rect.left,
      });
    }

    if (!open) {
      setOpen(true);
      if (onOpen) onOpen();
    } else {
      setOpen(false);
      if (onClose) onClose();
    }
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        popupRef.current &&
        !popupRef.current.contains(e.target) &&
        !triggerRef.current.contains(e.target)
      ) {
        close();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () =>
      document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <>
      <span
        ref={triggerRef}
        onClick={toggle}
        style={{ display: "inline-block" }}
      >
        {trigger}
      </span>

      {open && (
        <div
          ref={popupRef}
          style={{
            // ✅ CHANGED: absolute → fixed (prevents scroll offset bugs)
            position: "fixed",

            top: pos.top,
            left: pos.left,

            // (optional but recommended: prevents it overlapping trigger weirdly)
            transform: "translateY(-100%)",

            background: "white",
            border: "1px solid #ccc",
            borderRadius: 8,
            padding: 10,
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            zIndex: 9999,
          }}
        >
          {children}
        </div>
      )}
    </>
  );
}


/*
import { useEffect, useRef, useState } from "react";
export default function PopupWrapper({ trigger, children, onClose, onOpen }) {
  const [open, setOpen] = useState(false);
  const [pos, setPos] = useState({ top: 0, left: 0 });
  const triggerRef = useRef(null);
  const popupRef = useRef(null);

  const close = () => {
    setOpen(false);
  
    if (onClose) onClose();
  };

  const toggle = () => {
    if (!open && triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();

      setPos({
        top: rect.top + window.scrollY - 10,
        left: rect.left + window.scrollX,
      });
    }
    if (!open) {
      setOpen(true);
      if (onOpen) onOpen();
    } else {
      setOpen(false);
      if (onClose) onClose();
    }
    // setOpen(!open);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        popupRef.current &&
        !popupRef.current.contains(e.target) &&
        !triggerRef.current.contains(e.target)
      ) {
        close();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () =>
      document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <>
      <span
        ref={triggerRef}
        onClick={toggle}
        style={{ display: "inline-block" }}
      >
        {trigger}
      </span>

      {open && (
        <div
          ref={popupRef}
          style={{
            position: "absolute",
            top: pos.top,
            left: pos.left,
            transform: "translateY(-100%)",
            background: "white",
            border: "1px solid #ccc",
            borderRadius: 8,
            padding: 10,
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            zIndex: 9999,
          }}
        >
          {children}
        </div>
      )}
    </>
  );
}
*/

